import React, { useCallback, useState, useEffect } from 'react';
import Typography from '@material-ui/core/Typography';
import { useTextSwitchStyles } from './styles';
import Info from 'components/Tooltip/Info';

interface OwnProps {
  id: string;
  label?: string;
  afterChange?: () => void;
  check?: () => Promise<boolean>;
  disabled?: boolean;
  checked?: boolean;
  fullWidth?: boolean;
  options: [
    { label?: string; icon?: React.ReactElement; info?: string },
    { label?: string; icon?: React.ReactElement; info?: string },
  ];
}

type Props = OwnProps;

const TextSwitch: React.FC<Props> = ({ id, label, afterChange, check, disabled, checked, fullWidth, options }) => {
  const [callAfterChange, setCallAfterChange] = useState(false);
  const [internalChecked, setInternalChecked] = useState(!!checked);
  const classes = useTextSwitchStyles({ fullWidth });

  // If there is afterChange callback
  // and the field value changed, call it.

  useEffect(() => {
    (async () => {
      if (callAfterChange) {
        setCallAfterChange(false);
        if (check) {
          const result = await check?.();
          if (!result) setInternalChecked((prev) => !prev);
        } else {
          afterChange?.();
        }
      }
    })();
  }, [callAfterChange, afterChange, check]);

  useEffect(() => {
    setInternalChecked(!!checked);
  }, [checked, id]);

  const onChange = useCallback(
    (e: React.FocusEvent<any>) => {
      // If there is afterChange callback, set the flag
      // which informs the component to call the callback after
      // it do it's own onBlur and rerender with new props

      setInternalChecked(!internalChecked);

      if (afterChange || check) {
        setCallAfterChange(true);
      }
    },
    [afterChange, check, internalChecked],
  );

  return (
    <div className={`${classes.root} ${disabled ? classes.disabled : ''}`}>
      <input
        id={id}
        name={id}
        type="checkbox"
        className={classes.checkbox}
        onChange={onChange}
        disabled={disabled}
        checked={internalChecked}
      />
      <label htmlFor={id} className={classes.label}>
        {label && (
          <div className={classes.realLabel}>
            <Typography component="span">{label}</Typography>
          </div>
        )}
        <div className={classes.switch}>
          <span>
            {options[0].label}
            {options[0].icon}
            {options[0].info && <Info content={options[0].info} button black />}
          </span>
          <span>
            {options[1].label}
            {options[1].icon}
            {options[1].info && <Info content={options[1].info} button black />}
          </span>
        </div>
      </label>
    </div>
  );
};

export default TextSwitch;
